import React, { useState } from 'react';
import { useContext } from 'react';
import { AuthContext } from '../../../../common/authContext';
import Container from '../../../Common/Container';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import messages from './messages';
import { useHistory } from 'react-router-dom';
import theme from '../../../../common/theme';
import Header from '../../../../containers/User/HeaderContainer';
import BackToAdminPanel from '../BackToAdminPanel/BackToAdminPanel';
import { getReport } from '../../../../services/reports.service';

const transformJSONArrayToCSV = (jsonArray: Array<Array<string | number>>) => {
  if (jsonArray.length === 0) {
    return '';
  }

  const csvRows = [];

  for (const row of jsonArray) {
    const values = row.map(value => {
      const escapedValue = String(value).replace(/"/g, '""');
      return `"${escapedValue}"`;
    });
    csvRows.push(values.join(','));
  }

  return csvRows.join('\n');
};

export default function ReportsScreen() {
  const history = useHistory();
  const { authUser } = useContext(AuthContext);
  const [loadingReport, setLoadingReport] = useState(false);

  if (!authUser?.isSuperAdmin) {
    history.push('/');
  }

  const generateReport = (reportType: string) => {
    if (loadingReport) return; // Prevent multiple clicks while loading
    setLoadingReport(true);
    getReport(reportType)
      .then(reportData => {
        const csvData = transformJSONArrayToCSV(reportData);
        const blob = new Blob([csvData], { type: 'text/csv' });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = `${reportType}-report-${new Date().toDateString()}.csv`;
        document.body.appendChild(a);
        a.click();
        a.remove();
      })
      .catch(error => {
        console.error('Error fetching report:', error);
      })
      .finally(() => {
        setLoadingReport(false);
      });
  };

  return (
    <>
      <Header />
      <Container
        maxWidth="xl"
        component="div"
        disableGutters
        style={{ padding: theme.spacing(4) }}
      >
        <BackToAdminPanel />
        {loadingReport && (
          <Typography variant="h6">
            <FormattedMessage {...messages.loadingReport} />
          </Typography>
        )}
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>
                  <Typography variant="h6" style={{ fontWeight: 'bold' }}>
                    <FormattedMessage {...messages.reports} />
                  </Typography>
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              <TableRow
                key="buyers-report"
                hover
                onClick={() => generateReport('buyers')}
                style={{ cursor: 'pointer' }}
              >
                <TableCell>
                  <FormattedMessage {...messages.buyers} />
                </TableCell>
              </TableRow>
              <TableRow
                key="sellers-report"
                hover
                onClick={() => generateReport('sellers')}
                style={{ cursor: 'pointer' }}
              >
                <TableCell>
                  <FormattedMessage {...messages.sellers} />
                </TableCell>
              </TableRow>
              <TableRow
                key="realtors-activity-report"
                hover
                onClick={() => generateReport('realtor-activity')}
                style={{ cursor: 'pointer' }}
              >
                <TableCell>
                  <FormattedMessage {...messages.realtorsActivity} />
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        {/* <Grid container justifyContent="center">
          
          <Box
            marginTop={theme.spacing(4)}
            width="100%"
            display="flex"
            justifyContent="center"
            style={{ gap: theme.spacing(2) }}
          >
            <Button
              size="large"
              color="primary"
              variant="contained"
              onClick={() => generateReport('realtors')}
              disabled={loadingReport}
            >
              <FormattedMessage {...messages.realtors} />
            </Button>
            <Button
              size="large"
              color="primary"
              variant="contained"
              onClick={() => generateReport('clients')}
              disabled={loadingReport}
            >
              <FormattedMessage {...messages.clients} />
            </Button>
          </Box>
        </Grid> */}
      </Container>
    </>
  );
}
